import { HttpService } from "../http";
import { getBaseUrl } from "@root/store/selectors/features";
import { store } from "@root/store";

export class DepartmentsService extends HttpService {
  baseUrl = getBaseUrl(store.getState());

  fetchDepartments = async (payload: any = {}): Promise<any> => {
    const apiUrl = `${this.baseUrl}/api/departments`;
    try {
      const apiResponse = await this.get(apiUrl, payload);
      return apiResponse;
    } catch (error) {
      throw error;
    }
  };
}
